export function keyNotation(notation) {
  if (keyNotationValid(notation)) {
    return keyCoordinates(notation.split(','));
  }
  return null;
}

export function keyNotationValid(notation) {
  if (notation.indexOf(' ') > -1) {
    return false;
  }
  if (notation.indexOf("<kbd>") > -1) {
    return false;
  }
  return notation.split(',').every(key => key !== '');
}

function keyCoordinates(keys) {
  let previousLength = 0;
  return keys.map(key => {
    const coordinate = {key, start: previousLength, end: previousLength + key.length};
    previousLength += key.length + 1; // This "1" is the length of the separator, in our case ','
    return coordinate;
  });
}
